export default {"src":"/_next/static/media/user-friendly.4df9030c.svg","height":107,"width":92};